import { TextAndShapesPalette } from "lib/styles/colors";
import { ReactElement } from "react";
import styled from "styled-components";
import Text, { TextType } from "./Text";
import responsiveStyling from "lib/responsive";

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 8px;
  border-bottom: 4px solid var(--basic-decoration-gray, #f2f2f2);
  ${responsiveStyling({
    ">768": `
    padding: 24px 16px;
    `,
  })}
`;

const StyledTitleText = styled.p`
  color: ${TextAndShapesPalette.BRAND_BLACK};
  margin-top: 16px;
  font-style: normal;
  font-weight: 600;
  font-family: Gilroy;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.375rem;
  ${responsiveStyling({
    ">768": `
    font-weight: 600;
    font-family: Gilroy;
    font-size: 2rem;
    font-weight: 600;
    line-height: 3rem;
    `,
  })}
`;

interface Props {
  title: string;
  subtitle?: string;
}

export function ResponsiveHeader({ title, subtitle }: Props): ReactElement {
  return (
    <HeaderContainer>
      <StyledTitleText>{title}</StyledTitleText>
      {subtitle && <Text type={TextType.PARAGRAPH}>{subtitle}</Text>}
    </HeaderContainer>
  );
}
